import { Model } from "pinia-orm";

import Marker from "./Marker";

export default class OtherItem extends Model {
  static entity = "other_items";
  static primaryKey = "uuid";
  static aosType = "OTHER_ITEM";

  static typeKey = "otherItemType";

  static types() {
    return {
      OTHER_ITEM_FUSION: OtherItemFusion,
    };
  }

  static fields() {
    return {
      uuid: this.uid(""),
      label: this.string(""),
      usage: this.attr(null),
      temporality: this.attr(null),
      content: this.attr(null),
      remarks: this.attr(null),
      pictureUuid: this.attr(null),
      tagsType: this.attr([]),
      typology: this.string("OTHER_ITEM"),
      impactedEnvironment: this.attr(null),
      incertitudeDescription: this.attr(null),
      incertitudeCategory: this.attr(null),

      marker: this.morphOne(Marker, "markable_id", "markable_type"),
    };
  }
}

export class OtherItemFusion extends OtherItem {
  static entity = "otherItemFusions";
  static primaryKey = "uuid";
  static baseEntity = "other_items";

  static fields() {
    return {
      ...super.fields(),
      otherItems: this.attr([]),
      otherItemType: this.string("OTHER_ITEM_FUSION"),
    };
  }
}
